/**
 * https://mjrussell.github.io/redux-auth-wrapper/docs/Getting-Started/ReactRouter3.html
 */

import locationHelperBuilder from 'redux-auth-wrapper/history3/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect';

const locationHelper = locationHelperBuilder({})

export const userIsAuthenticated = connectedRouterRedirect({
    redirectPath: '/login',
    authenticatedSelector: state => state.user.currentUser !== null,
    wrapperDisplayName: 'UserIsAuthenticated'
  })

  export const userIsNotAuthenticated = connectedRouterRedirect({
    // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
    redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/home',
    // This prevents us from adding the query parameter when we send the user away from the login page
    allowRedirectBack: false,
    // Determine if the user is authenticated or not
    authenticatedSelector: state => state.user.isAuthenticated !== null && state.user.isAuthenticated === true,
    // A nice display name for this check
    wrapperDisplayName: 'UserIsNotAuthenticated'

  })


// WEBPACK FOOTER //
// ./src/auth.js